<template>
    <a-cascader
        :fieldNames="fieldNames" :options="areaList"
        @change="change" v-bind="$attrs" v-model="areaValue" v-on="$listeners"/>
</template>

<script>
    import func from "../utils/func";

    export default {
        name: "AreaPicker",
        props: {
            level: {
                type: Number,
                default: 3,
            },
        },
        data() {
            return {
                areaList: [],
                fieldNames: {
                    value: "code",
                    label: "name",
                    children: "children"
                }
            };
        },
        computed: {
            areaValue: {
                get() {
                    if (!this.$attrs.value[0]) return [];
                    return [
                        this.$attrs.value[0].substr(0, 2) + "0000",
                        this.$attrs.value[0].substr(0, 4) + "00",
                        this.$attrs.value[0],
                    ];
                },
                set() {
                    // use change event instead
                }
            }
        },
        mounted() {
            this.$store.dispatch("area/level", this.level)
                .then(res => this.areaList = res.data);
        },
        methods: {
            change(value, opts) {
                let names = [];
                if (func.isDefined(opts)) {
                    opts.forEach(opt => {
                        names.push(opt.name);
                    });
                }
                let detail = this.$attrs.value.length > 2 ? this.$attrs.value[2] : "";
                this.$emit("input", [value.pop(), names.join(" "), detail]);
            }
        }
    };
</script>
